export default {
  rooms: 'Rooms:',
  area: 'Area:',
  ai_predictions_title: '📊 Predicted prices by AI',
  more: 'More details +',

  // 🏷 Transaction type
  purpose: {
    sale: 'For sale',
    rent: 'For rent',
    short_term: 'Short-term rent'
  }
}
